import axios from "axios";
import authHeader from "./auth-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/Feature/BytePro`;

class LoanService {
  getFileData(loanNumber, detailLevel) {
    return axios
      .get(
        `${API_URL}/fileData?loanNumber=${loanNumber}&detailLevel=${detailLevel}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getPipelineByDateRange(fileDataSearchOption) {
    return axios
      .post(`${API_URL}/PipelineByDateRange`, fileDataSearchOption, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getSubmissionPipeline() {
    return axios
      .get(`${API_URL}/SubmissionPipeline`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getOrganizations() {
    return axios
      .get(`${API_URL}/organizations`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getPrintSets() {
    return axios
      .get(`${API_URL}/PrintSets`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getPrintSetItems() {
    return axios
      .get(`${API_URL}/PrintSetItems`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getDocumentProperties(loanNumber) {
    return axios
      .get(`${API_URL}/DocumentProperties?loanNumber=${loanNumber}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getEmbeddedDocs(loanNumber) {
    return axios
      .get(`${API_URL}/EmbeddedDocs?loanNumber=${loanNumber}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getDocSigners(loanNumber) {
    return axios
      .get(`${API_URL}/DocSigners?loanNumber=${loanNumber}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getDocPackages(loanNumber) {
    return axios
      .get(`${API_URL}/DocPackages?loanNumber=${loanNumber}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getDocPackagesDocuSign() {
    return axios
      .get(`${API_URL}/DocPackages/DocuSign`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getDisclosureLogEntries(loanNumber) {
    return axios
      .get(`${API_URL}/DisclosureLogEntries?loanNumber=${loanNumber}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }
}

export default new LoanService();
